module.exports = "<div><h4>Location:</h4><div id=\"site-loc\" class=\"set-location\"></div></div>";